/**
 * Wishlist - localStorage-based favourites
 * Toggle hearts on product pages, counter in header, render wishlist page
 */
(function () {
  "use strict";

  var STORAGE_KEY = "lithofin_wish";

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* quota */ }
  }

  function isWished(id) {
    return getWishlist().some(function (p) { return p.id === id; });
  }

  function toggle(product) {
    var list = getWishlist();
    var idx = list.findIndex(function (p) { return p.id === product.id; });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.unshift(product);
    }
    saveWishlist(list);
    updateUI();
  }

  function updateUI() {
    var list = getWishlist();

    // Update header counter
    var counters = document.querySelectorAll(".header__wish-count");
    counters.forEach(function (el) {
      el.textContent = String(list.length);
      el.style.display = list.length > 0 ? "flex" : "none";
    });

    // Update heart buttons
    document.querySelectorAll("[data-wish-id]").forEach(function (btn) {
      var id = parseInt(btn.dataset.wishId, 10);
      btn.classList.toggle("wished", isWished(id));
    });

    // Render wishlist page if container exists
    renderPage(list);
  }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  function renderPage(list) {
    var container = document.getElementById("wishlist-page");
    if (!container) return;

    if (list.length === 0) {
      container.innerHTML =
        '<p class="wishlist__empty">' +
        esc(container.dataset.empty || "Your wishlist is empty.") +
        "</p>";
      return;
    }

    var html = '<div class="wishlist__grid">';
    list.forEach(function (p) {
      html += '<div class="wishlist__card">';
      html +=
        '<button class="wishlist__remove" data-wish-remove="' +
        p.id +
        '" aria-label="Remove">';
      html +=
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      html += "</button>";
      html += '<a href="' + esc(p.url) + '" class="wishlist__link">';
      if (p.img)
        html +=
          '<img class="wishlist__img" src="' +
          esc(p.img) +
          '" alt="" loading="lazy" width="200" height="200">';
      html += '<span class="wishlist__name">' + esc(p.title) + "</span>";
      if (p.price)
        html += '<span class="wishlist__price">' + esc(p.price) + "</span>";
      html += "</a></div>";
    });
    html += "</div>";
    container.innerHTML = html;

    // Bind remove buttons
    container.querySelectorAll("[data-wish-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = parseInt(this.dataset.wishRemove, 10);
        var list = getWishlist().filter(function (p) { return p.id !== id; });
        saveWishlist(list);
        updateUI();
      });
    });
  }

  // Heart button click handler (product page)
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wish-id]");
    if (!btn) return;
    e.preventDefault();
    var product = {
      id: parseInt(btn.dataset.wishId, 10),
      title: btn.dataset.wishTitle || "",
      url: btn.dataset.wishUrl || "",
      img: btn.dataset.wishImg || "",
      price: btn.dataset.wishPrice || "",
    };
    toggle(product);
  });

  // Init on DOM ready
  updateUI();
})();
